var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_3045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.1704C2.96533 11.1704 0.45166 8.66211 0.45166 5.62207C0.45166 2.5874 2.95996 0.0737305 5.99463 0.0737305C9.03467 0.0737305 11.5483 2.5874 11.5483 5.62207C11.5483 8.66211 9.03467 11.1704 6 11.1704ZM6 10.0801C8.4707 10.0801 10.458 8.09277 10.458 5.62207C10.458 3.15137 8.46533 1.16943 5.99463 1.16943C3.52393 1.16943 1.54736 3.15137 1.54736 5.62207C1.54736 8.09277 3.5293 10.0801 6 10.0801ZM3.28223 6.28809C3.04053 6.28809 2.85791 6.1001 2.85791 5.86377C2.85791 5.62207 3.04053 5.43945 3.28223 5.43945H5.57031V2.34033C5.57031 2.104 5.7583 1.91602 5.99463 1.91602C6.23633 1.91602 6.42432 2.104 6.42432 2.34033V5.86377C6.42432 6.1001 6.23633 6.28809 5.99463 6.28809H3.28223Z",
    fill: "#FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_3045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.72bc33adf86e3d4d90907faa03c4b61e.svg";
export { ForwardRef as ReactComponent };